import "./TestDetailsComponent.scss";
import HeadingComponent from "../heading/headingComponent";
import commonService from "../../services/common.service";
import ChipComponent from "../chip/ChipComponent";
import React from "react";

interface TestDetailsComponentProps {
    activeTab:  "tests" | "test_panels";
    TESTS: 'tests';
    TEST_PANELS: 'test_panels';
    testOrPanelDetails: any;
}

const TestDetailsComponent = (props: TestDetailsComponentProps) => {
    const {activeTab,TESTS,TEST_PANELS,testOrPanelDetails}=props;

    return (
        <div className={'test-details-component screen t-form-screen'}>
            <div className="drawer-sub-header horizontal-vertical-center-align">
                <HeadingComponent title={activeTab === TESTS ? "Test Details" : "Test Panel Details"}/>
            </div>
            <div className={'drawer-view-details-card'}>
                {
                    activeTab === TEST_PANELS ? <>
                            <div className={'drawer-key-value'}>
                                <div className={'drawer-key'}>
                                    Test Panel Name:
                                </div>
                                <div className={'drawer-value'}>
                                    {testOrPanelDetails?.name ? commonService.capitalizeFirstLetterOfEachWord(testOrPanelDetails?.name) : 'N/A'}
                                </div>
                            </div>
                            <div className={'drawer-key-value'}>
                                <div className={'drawer-key'}>
                                    Test Panel Code:
                                </div>
                                <div className={'drawer-value'}>
                                    {testOrPanelDetails?.code || 'N/A'}
                                </div>
                            </div>
                            {/*<div className={'drawer-key-value'}>*/}
                            {/*    <div className={'drawer-key'}>*/}
                            {/*        Description:*/}
                            {/*    </div>*/}
                            {/*    <div className={'drawer-value'}>*/}
                            {/*        {testOrPanelDetails?.description || 'N/A'}*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className={'horizontal-line'}></div>
                            <div className={'drawer-key-value'}>
                                <div className={'drawer-key'}>
                                    Test(s):
                                </div>
                                {
                                    testOrPanelDetails?.tests?.length > 0 ?
                                        <div className={'drawer-value-chips'}>
                                            {testOrPanelDetails?.tests?.map((test: any, index: number) => {
                                                return (
                                                    <div key={index} className={'drawer-value'}>
                                                        <ChipComponent label={test}/>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        :
                                        <>N/A</>
                                }
                            </div>
                        </> :
                        <>
                            <div className={'drawer-key-value'}>
                                <div className={'drawer-key'}>
                                    Test Name:
                                </div>
                                <div className={'drawer-value'}>
                                    {testOrPanelDetails?.name ? commonService.capitalizeFirstLetterOfEachWord(testOrPanelDetails?.name) : 'N/A'}
                                </div>
                            </div>
                            <div className={'drawer-key-value'}>
                                <div className={'drawer-key'}>
                                    Test Code:
                                </div>
                                <div className={'drawer-value'}>
                                    {testOrPanelDetails?.code || 'N/A'}
                                </div>
                            </div>
                            {/*<div className={'drawer-key-value'}>*/}
                            {/*    <div className={'drawer-key'}>*/}
                            {/*        Description:*/}
                            {/*    </div>*/}
                            {/*    <div className={'drawer-value'}>*/}
                            {/*        {testOrPanelDetails?.description || 'N/A'}*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className={'horizontal-line'}/>
                            <div className={'drawer-key-value'}>
                                <div className={'drawer-key'}>
                                    Collection Device:
                                </div>
                                <div className={'drawer-value'}>
                                    {testOrPanelDetails?.sampleCollectionDeviceName || 'N/A'}
                                </div>
                            </div>
                            <div className={'drawer-key-value'}>
                                <div className={'drawer-key'}>
                                    Sample Type:
                                </div>
                                <div className={'drawer-value'}>
                                    {testOrPanelDetails?.sampleType || 'N/A'}
                                </div>
                            </div>
                            <div className={'drawer-key-value'}>
                                <div className={'drawer-key'}>
                                    Sample Quantity:
                                </div>
                                <div className={'drawer-value'}>
                                    {testOrPanelDetails?.sampleQuantity || 'N/A'}
                                </div>
                            </div>
                            <div className={'horizontal-line'}/>
                            <div className={'drawer-key-value'}>
                                <div className={'drawer-key'}>
                                    Biomarker(s):
                                </div>
                                {
                                    testOrPanelDetails?.biomarkers?.length > 0 ?
                                        <div className={'drawer-value-chips'}>
                                            {testOrPanelDetails?.biomarkers?.map((biomarker: any, index: number) => {
                                                return (
                                                    <div key={index} className={'drawer-value'}>
                                                        <ChipComponent label={biomarker}/>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        :
                                        <>N/A</>
                                }
                            </div>

                        </>
                }
            </div>
        </div>
    );

};

export default TestDetailsComponent;
